module.exports = __webpack_public_path__ + "static/greydressing-e2149c091ea65997115bc1ad306bb909.png";